<script lang="ts" setup>
import VDropdown from '~/components/common/VDropdown.vue';
import ContextMenuCell from '~/components/ContextMenuCell.vue';
import HeaderAvatar from '../common/HeaderAvatar.vue';

const route = useRoute();
const userStore = useUserStore();
const authStore = useAuthStore();

const onLogout = () => {
  authStore.logout();

  setTimeout(() => {
    if (route.name === 'profile') {
      navigateTo('/');
    } else {
      reloadNuxtApp();
    }
  }, 0);

  userStore.user = undefined;
};

const dropdownItems = computed(() => {
  const items = [
    {
      title: 'Программа лояльности',
      onclick: () => navigateTo('/loyalty/levels'),
    },
    {
      title: 'Выйти',
      onclick: onLogout,
    },
  ];

  return items;
});
</script>

<template>
  <div class="dropdown-container">
    <v-dropdown
      v-if="userStore.user"
      width="218px"
      padding="4px"
      class="dropdown"
    >
      <HeaderAvatar chevron />

      <template #body>
        <ul class="dropdown-list">
          <template
            v-for="(item, index) in dropdownItems"
            :key="item.title"
          >
            <li>
              <context-menu-cell
                small
                @click="item.onclick"
              >
                {{ item.title }}
              </context-menu-cell>
            </li>
            <v-divider v-if="index === dropdownItems.length - 2" />
          </template>
        </ul>
      </template>
    </v-dropdown>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-container {
  display: flex;
  gap: 30px;

  @include media-breakpoint-down(lg) {
    gap: 24px;
  }

  @include media-breakpoint-down(md) {
    display: none;
  }

  .dropdown {
    .dropdown__body {
      .divider {
        background: rgba($foreground-contrast, 0.1);
      }
    }

    .dropdown-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 10px;

      .divider {
        background-color: $background-gray;
      }

      li .context-menu-cell {
        padding: 8px 12px;
      }
    }

    .avatar-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      border-radius: 12px;
      transition: 0.3s;
      padding: 4px;

      &:hover {
        background: $background-button-secondary-hover;
      }

      .avatar-image {
        object-fit: cover;
        max-width: 32px;
        width: 32px;
        max-height: 32px;
        height: 32px;
        border-radius: 100px;
      }

      .avatar-button {
        padding: 0;
        width: 32px;
        height: 32px;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
        border-radius: 100px;
        border: 1px solid $background-button-secondary-hover;
        background: $background-theme-fade;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $foreground-theme;
        background: white;

        &.avatar-button-mobile {
          display: none;

          @include media-breakpoint-down(md) {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
